import { Component, OnInit, Injector } from '@angular/core';
import { AuditService } from '../../_service/audit.service';
import { PageableComponent } from '../../_components/PageableComponent';
import AuditSearch from '../../models/AuditSearch';
import Audit  from '../../models/Audit';

@Component({
  selector: 'app-audit-manager',
  templateUrl: './audit-manager.component.html',
  styleUrls: ['./audit-manager.component.css']
})
export class AuditManagerComponent extends PageableComponent implements OnInit {

  audit_search : AuditSearch = new AuditSearch();
  audits       : Audit[] = [];   

  //OPERATION RESULT AS TEXT
  //displayed_columns             = [ 'owner', 'timestamp', 'object_type', 'author', 'operation_type' , 'operation_result' , 'operation_info' ];
  //OPERATION RESULT AS ICON
  displayed_columns             = [ 'owner', 'timestamp', 'object_type', 'author', 'operation_type' , 'operation_result_icon' , 'operation_info' ];

  constructor(
    injector : Injector,
    private _auditService : AuditService
    ) 
  { 
  super(injector);
    
  }

  ngOnInit() 
  {
    this.setPageChangeCallback(this._getAudit);
    this.addOrdering("timestamp","desc");
    this._getAudit();

  }

  getOwnerIcon(element)
  {
    var logged_user   = this._userService.getLoggedUser();
    return element.operation_user === logged_user.username ? "stars" : "";
  }

  search()
  {
    this._getAudit();
  }

  _getAudit()
  {
    this.loading = true;
    this._auditService.getAudit(this.audit_search,this.per_page, this.page_number,this.order_info).subscribe(
      data => {
        this.total_rows         = data["retdata"]["total"];
        this.audits             = [];
        this.loading            = false;
        
        for (var current of data["retdata"]["data"])
        {
           this.audits.push(new Audit(current));
        }
      },
      err => {
        this.loading = false;
        this._interfaceService.openSimpleErrorSnackBar(err);
    });
  }

}
